import type { ICapability } from '@/types/capability'
import { CONTEXT_DOCUMENTS_ROUTE } from './contextDocuments'
import { SUPPLIER_QUESTIONNAIRES } from './supplierQuestionnaires'
import { TEXT_DOCUMENT_ROUTES } from './documents'
import { SAAS_MANAGEMENT_URL } from './employees'
// Capabilities still in use, the ones CS metrics count
export const TRACKED_CAPABILITIES = [
  'compliance',
  'assetManagement',
  'suppliers',
  'easm',
  'infrastructure',
  'cloudSecurity',
  'appsec',
  'crisisManager',
  'mdm',
  'phishingExercises',
  'identities',
] as const
export const DEPRECATED_CAPABILITIES = [
  'people',
  'automatedPentesting',
  'edrSiem',
  'endpointProtection',
  'employeesTraining',
  'passwordManager',
  'codeScanner',
  'homeDashboard',
  'riskAssessment',
  'reports',
  'trustCenter',
] as const
export const CAPABILITIES = [...TRACKED_CAPABILITIES, ...DEPRECATED_CAPABILITIES] as const
// A capability is in use when a client user opened it in the last week
export const CAPABILITY_IN_USE_DAYS = 7
export const CAPABILITIES_URL_MAP: Record<ICapability, { urls: string[]; allowSlug?: boolean }> = {
  compliance: {
    urls: [
      '/',
      '/compliance/controls',
      '/compliance/controls',
      '/compliance/documents',
      // `allowSlug` strips the `[id]`, so these cover `/edit/5` and `/view/5`.
      TEXT_DOCUMENT_ROUTES.EDIT,
      TEXT_DOCUMENT_ROUTES.VIEW,
      '/compliance/new-documents',
      '/compliance/evidences',
      '/compliance/new-evidences',
      '/compliance/tasks',
      '/suppliers/dashboard',
      '/suppliers/questionnaires',
      CONTEXT_DOCUMENTS_ROUTE,
      '/compliance/risk-manager',
      '/people/employee-dashboard',
      SAAS_MANAGEMENT_URL,
      '/compliance/non-conformities',
      SUPPLIER_QUESTIONNAIRES.BACKOFFICE_PATH,
      '/approved-software',
    ],
    allowSlug: true,
  },
  assetManagement: {
    urls: ['/assets/laptops', '/assets/servers', '/asset-manager', '/it-inventory'],
  },
  suppliers: { urls: ['/suppliers/dashboard'] },
  easm: {
    urls: ['/easm/public-domains', '/easm/vulnerabilities', '/easm/certificates', '/easm/breaches', '/easm/dashboard'],
  },
  people: {
    urls: ['/people/endpoints-compliance'],
  },
  infrastructure: {
    urls: ['/infrastructure/alerts', '/infrastructure/vulnerabilities', '/infrastructure/dashboard'],
  },
  cloudSecurity: {
    urls: ['/cloud-security/dashboard', '/cloud-security/misconfigurations'],
  },
  appsec: {
    urls: [
      '/appsec/dashboard',
      '/appsec/sast',
      '/appsec/sca',
      '/appsec/secrets-detection',
      '/appsec/sbom',
      '/appsec/containers-scan',
      '/appsec/dast',
    ],
  },
  automatedPentesting: { urls: [] },
  edrSiem: { urls: ['/infrastructure/endpoint-monitoring'] },
  endpointProtection: { urls: [] },
  employeesTraining: { urls: ['/people/employees-training'] },
  phishingExercises: { urls: ['/people/phishing-campaigns', '/people/phishing-campaigns/campaign'], allowSlug: true },
  passwordManager: { urls: ['/people/password-manager'] },
  codeScanner: { urls: [] },
  homeDashboard: { urls: [] },
  riskAssessment: { urls: [] },
  reports: { urls: [] },
  trustCenter: { urls: [] },
  identities: { urls: ['/people/identities'] },
  crisisManager: { urls: ['/crisis-manager'] },
  mdm: { urls: ['/mdm/dashboard', '/mdm/hosts', '/mdm/groups', '/mdm/policies', '/mdm/software', '/mdm/scripts'] },
}
